@use "../common/common.scss" as *;
@import "../../common/styles.scss";
@import "../../../../../node_modules/@genexus/mercury/dist/assets/scss/helpers.scss";
@import "../../../../global/gx-ide-mixins.scss";
@import "../../../../global/temporary-mercury-overrides/_button.scss";

// header detail
.header__details {
  grid-template-areas:
    "detail-heading-gx . . ."
    "detail-genexus-server detail-knowledge-base detail-version detail-last-full-update";
}

.detail__heading-genexus-server {
  grid-area: detail-heading-gx;
}
.detail__genexus-server {
  grid-area: detail-genexus-server;
  @extend %header-detail-start;
}
.detail__knowledge-base {
  grid-area: detail-knowledge-base;
  @extend %header-detail-common;
}
.detail__version {
  grid-area: detail-version;
  @extend %header-detail-end;
}

// filter
.filter-container {
  container-type: inline-size;
  box-sizing: border-box;
  display: grid;
  column-gap: var(--spacing-gap-l);
  grid-template-areas:
    "filter-primary filter-toggle-button filter-action-buttons"
    "filter-secondary . ."
    "comments comments comments";
  grid-template-columns: minmax(0, max-content) max-content 1fr;
}
.filter {
  @extend %filter;
}
.filter-primary {
  grid-area: filter-primary;
  grid-template-columns: $filterControlInlineSize $filterControlInlineSize $filterControlInlineSize;
}
.filter-container > :nth-child(2) {
  grid-area: filter-toggle-button;
}
.filter-container > :nth-child(3) {
  grid-area: filter-action-buttons;
  justify-content: end;
}
.filter__toggle-secondary-filter-btn {
  grid-area: filter-toggle-button;
}

.filter__buttons {
  grid-area: filter-buttons;
  margin-inline-start: auto;
}

// secondary filter (hidden by default)
.filter-secondary {
  display: grid;
  grid-template-rows: 0fr;
  grid-area: filter-secondary;
  transition: grid-template-rows var(--timing-fast);
}
.filter-secondary--visible {
  grid-template-rows: 1fr;
}
.filter-secondary > div {
  @extend %filter;
  display: grid;
  overflow: hidden;
  font-size: 0; // WA Remove unwanted additional space
  grid-template-columns: repeat(3, $filterControlInlineSize);
}

.filter-secondary > div > .combo-box,
.comments {
  margin-block-start: $filterRowGap;
}
.comments {
  grid-area: comments;
}

// - - - - - - - - - - - - - -
// WA (WORK AROUNDS)
// - - - - - - - - - - - - - -

.input-comments-container {
  position: relative;
}
// ch-edit for comments WA's
// Figma design for this component displays the textarea witout border, and with a little more line-height.
// The following styles are a temporary WA that should be brouhgt to Mercury DS.
.input-comments {
  --control-border-color: transparent;
  padding-block: 0 !important;
  padding-inline: 0 !important;
  --line-height-tight: 1.4;
  block-size: 100%;
  background-color: var(--color-accent-surface-surface);
  transition:
    var(--timing-super-fast) block-size,
    var(--timing-super-fast) background-color,
    var(--timing-super-fast) padding-block,
    var(--timing-super-fast) padding-inline;
}
.input-comments:focus {
  position: absolute;
  block-size: $filterControlInlineSize;
  inline-size: 100%;
  z-index: 99;
  background-color: var(--color-accent-surface-elevation-1);
  padding-block: var(--control-padding-block) !important;
  padding-inline: var(--control-padding-inline) !important;
}
